export default __webpack_public_path__ + "static/white-0d4093bd2c0e1f0f3e4f82bcc3c39c0f.png";